export default __webpack_public_path__ + "static/media/afterparty_logo_square.e7fc3eb8.jpeg";